"use strict";

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

define(['app', './base', './../translationsUtils/modal', 'magnific-popup'], function (app, Helper, TranslationModalSanatizer) {
  return Helper.extend({
    options: {
      delegate: 'a.popup',
      type: false
    },
    bindGallery: function bindGallery() {
      var opts = {
        type: this.options.type,
        delegate: this.options.delegate,
        gallery: {
          enabled: true,
          cursor: null
        },
        inline: {
          cursor: null
        },
        image: {
          cursor: null
        },
        callbacks: {
          elementParse: function elementParse(item) {
            if (item.src) return; // Function will fire for each target element
            // "item.el" is a target DOM element (if present)
            // "item.src" is a source that you may modify

            item.src = item.el[0].src;
          },
          change: function change() {
            var _this$currItem$el;

            var uuid = (_this$currItem$el = this.currItem.el) === null || _this$currItem$el === void 0 ? void 0 : _this$currItem$el[0].dataset.fileUuid;

            if (uuid) {
              var xhr = new XMLHttpRequest(); // eslint-disable-line

              xhr.open('GET', (0, _absoluteUrlRuntime.resolveUrl)('/topic/trackAttachment?file_uuid=' + uuid));
              xhr.send();
            }
          }
        }
      };
      var modalTranslations = app.translations ? TranslationModalSanatizer(app.translations.get('modal')) : {};
      opts = app._.deepExtend({}, modalTranslations, opts);
      this.$el.magnificPopup(opts);
    },
    initialize: function initialize() {
      var _this = this;

      this.bindUIElements();

      if (!app.translations) {
        app.events.commands.setHandler('translations:mounted', function () {
          _this.bindGallery();
        });
      }

      this.bindGallery();
    }
  });
});